import { createContext, useContext, useReducer, useMemo } from 'react';
import { documentReducer, initialState } from './reducer';

const DocumentContext = createContext();

export const DocumentProvider = ({ children }) => {
    const [state, dispatch] = useReducer(documentReducer, initialState);
    const value = useMemo(() => [state, dispatch], [state]);
    return <DocumentContext.Provider value={value}>{children}</DocumentContext.Provider>;
};

export const useDocumentContext = () => {
    const context = useContext(DocumentContext);
    if (!context) {
        throw new Error('useDocumentContext must be used within a DocumentProvider');
    }
    return context;
};
